import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import {
  NomenclatureCreateModal,
  NomenclatureDeleteDialog,
  NomenclatureDuplicateModal,
  useResetNomenclatureStoreOnUnmount,
} from '@/components/nomenclature';
import { DataGridContainer, DataGridTitle, DataGridToolbar } from '@/components/ReactDataGrid';

import { ReconciliationNomenclatureDataGrid } from './ReconciliationNomenclatureDataGrid';
import { ReconciliationNomenclatureToolbar } from './ReconciliationNomenclatureToolbar';

export const ReconciliationNomenclatureList = () => {
  const { t } = useTranslation('orders-page');
  useResetNomenclatureStoreOnUnmount();

  return (
    <Fragment>
      <DataGridContainer>
        <DataGridToolbar>
          <DataGridTitle>{t('reconciliation.binding.nomenclature-title')}</DataGridTitle>
        </DataGridToolbar>
        <ReconciliationNomenclatureToolbar />
        <ReconciliationNomenclatureDataGrid />
      </DataGridContainer>

      <NomenclatureCreateModal />
      <NomenclatureDuplicateModal />
      <NomenclatureDeleteDialog />
    </Fragment>
  );
};
